import {
  getFacilityName,
  getFacilityLocation,
  getJobPay,
  getJobTotalCompensation,
  getJobType,
  getJobDeadlineDate,
  getJobPostedDate
} from './resultValueFormatters'

const showIfCompNotHidden = (job, option) => job.hide_compensation_from_job_board ? [] : [option]

export default job => [
  {
    iconName: 'building',
    value: getFacilityName(job)
  },
  {
    iconName: 'location',
    value: getFacilityLocation(job)
  },
  ...showIfCompNotHidden(job, {
    iconName: 'dollar',
    value: getJobPay(job)
  }),
  {
    iconName: 'calendar',
    value: getJobType(job)
  },
  {
    iconName: 'exclamation',
    value: getJobDeadlineDate(job)
  },
  {
    iconName: 'postjob',
    value: getJobPostedDate(job)
  },
  ...showIfCompNotHidden(job, {
    iconName: 'dollar',
    value: getJobTotalCompensation(job)
  })
]
